import { useSearchParams } from 'react-router';

const usePaginationSearchParams = (prefix: string) => {
  const [searchParams] = useSearchParams();
  const cursor = searchParams.get(`${prefix}Cursor`);
  const limit = searchParams.get(`${prefix}Limit`);
  const offset = searchParams.get(`${prefix}Offset`);
  const orderBy = searchParams.get(`${prefix}OrderBy`);

  return {
    cursor,
    limit: limit ? +limit : null,
    offset: offset ? +offset : null,
    orderBy: orderBy ? decodeURIComponent(orderBy) : null,
  };
};

export default usePaginationSearchParams;
